import axiosInstance from './axiosInstance';
import { API_BASE_URL } from '../config';

// Types
export interface SearchParams {
  source: string;
  keywords?: string;
  location?: string;
  price?: string;
}

export interface ImportParams {
  source: string;
  sourceId: string;
  data?: any;
}

export interface ImportSource {
  id: string;
  name: string;
  type: string;
  base_url: string;
  is_active: boolean;
}

// API calls
export const searchHotels = async (params: SearchParams) => {
  try {
    const response = await axiosInstance.get('/api/hotels/search-external', {
      params: {
        source: params.source,
        query: JSON.stringify({
          keywords: params.keywords,
          location: params.location,
          price: params.price,
        }),
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error searching hotels:', error);
    throw error;
  }
};

export const importHotel = async (params: ImportParams) => {
  try {
    const response = await axiosInstance.post('/api/hotels/import-external', params);
    return response.data;
  } catch (error) {
    console.error('Error importing hotel:', error);
    throw error;
  }
};

export const getImportSources = async () => {
  const response = await axiosInstance.get('/api/hotels/import-sources');
  return response.data;
};

export const getImportHistory = async (hotelId: string) => {
  try {
    const response = await axiosInstance.get(`/api/hotels/${hotelId}/import-history`);
    return response.data;
  } catch (error) {
    console.error('Error fetching import history:', error);
    throw error;
  }
};